"use strict";
import { dbFS, dbFB, functions } from "@/components/firebase.js";

let unsuscribeForm;

export default {
  state: {
    inmueblesForm: [],
    catastroSelect: null,
    consolidated: null,
    savedUser: null,
    savedCatastroUser: null,
    staticsFormsDetails: null,
    staticsFormsResume: null
  },

  getters: {
    staticsFormsDetails: state => {
      return state.staticsFormsDetails;
    },
    staticsFormsResume: state => {
      return state.staticsFormsResume;
    },
    filesForm: state => {
      return [];
    },
    inmueblesForm: state => {
      return state.inmueblesForm;

      let inmuebles = state.inmueblesForm;
      if (inmuebles) {
        for (let index = 0; index < inmuebles.length; index++) {
          let propietarios = inmuebles[index];
          if (propietarios) {
            propietarios = propietarios.filter(i => !i.consolidado);
            inmuebles[index].propietarios = propietarios;
          }
        }
      }
      return inmuebles;
      /* const propietarios =
        inmuebles && Array.isArray(inmuebles)
          ? inmuebles.map(i => i.propietarios)
          : []; */
      
      // return state.inmueblesForm;
    },
    propietariosForm: state => {
      const inmuebles = state.inmueblesForm;
      const propietarios =
        inmuebles && Array.isArray(inmuebles)
          ? inmuebles.map(i => i.propietarios)
          : [];
      return propietarios;
    }
  },

  mutations: {
    staticsForms: (state, payload) => {
      state.staticsFormsDetails = payload.detalle;
      state.staticsFormsResume = payload.total;
    },
    setInmuebles: (state, payload) => {
      state.inmueblesForm = payload;
    },

    unSetCatastroForm: state => {
      state.inmueblesForm = [];
      unsuscribeForm();
    },
    setCatastroSelected: (state, payload) => {
      state.catastroSelect = payload;
    },
    saveUserFormConsolidated: (state, payload) => {
      state.consolidated = payload;
    },
    saveUserConsolidated: (state, payload) => {
      state.savedUser = payload;
    },
    saveCatastroUserConsolidated: (state, payload) => {
      state.savedCatastroUser = payload;
    }
  },

  actions: {
    consolidaForm: ({ commit }, payload) => {
      const consolida = functions.httpsCallable("consolidaForm");
      consolida(payload)
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(data));
          if (data.data.success) {
            commit("saveCatastroUserConsolidated", payload.refUser);
          } else {
            // eslint-disable-next-line no-console
            console.log("pasó algo...");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    staticsForms: ({ commit }) => {
      let estadisticas = functions.httpsCallable("staticsForms");
      estadisticas()
        .then(data => {
          if (data.data.success) {
            commit("staticsForms", data.data);
          } else {
            // eslint-disable-next-line no-console
            console.log("pasó algo...");
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
    },
    saveCatastroUserConsolidated: ({ commit }, payload) => {
      const catastroAction = functions.httpsCallable("catastroAction");
      catastroAction(payload)
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(data));
          if (data.data.success) {
            commit("saveCatastroUserConsolidated", payload.refUser);
          } else {
            // eslint-disable-next-line no-console
            console.log("pasó algo...");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    saveUserConsolidated: ({ commit }, payload) => {
      // eslint-disable-next-line no-console
      console.log("Guardar usuario", payload.uid);
      dbFB
        .ref("users")
        .child(payload.uid)
        .set(payload.data);
      commit("saveUserConsolidated", payload.uid);
    },

    saveUserFormConsolidated: ({ commit }, payload) => {
      // eslint-disable-next-line no-console
      console.log("Consolidar Usuario", payload.sessionUid);
      dbFS
        .collection("users-forms")
        .doc(`${payload.refCat}`)
        .update({
          [payload.ruta1]: payload.data1,
          [payload.ruta2]: payload.data2
        })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Usuario Consolidado");
          commit("saveUserFormConsolidated", payload.sessionUid);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error Consolidando usuario", error);
        });
      /* dbFS
        .collection("users-forms-consolidated")
        .doc(`${payload.sessionUid}`)
        .set(payload.data)
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Usuario Consolidado");
          commit("saveUserFormConsolidated", payload.sessionUid);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error Consolidando usuario", error);
        }); */
    },

    setCatastroForm: ({ state, commit }, payload) => {
      if (state.catastroSelect === payload) {
        // eslint-disable-next-line
        console.log(`Los datos para ${payload} ya estaban cargados`);
        return;
      }
      commit("setCatastroSelected", payload);
      if (unsuscribeForm) {
        unsuscribeForm();
      }
      unsuscribeForm = dbFS
        .collection("users-forms")
        .doc(`${payload}`)
        .onSnapshot(
          doc => {
            let datos = doc.data();
            // eslint-disable-next-line
            console.log(datos);
            let inmuebles = datos ? datos.inmuebles : [];
            /* if (inmuebles && inmuebles.length > 0) {
              const propietarios = inmuebles.propietarios.filter(i => i.)
            } */
            commit("setInmuebles", inmuebles);
          },
          error => {
            // eslint-disable-next-line
            console.error(error)
          }
        );
    },

    unSetCatastroForm: ({ commit }) => {
      commit("unSetCatastroForm");
    },

    changeMostrarBurbuja: ({ commit }, payload) => {
      const controlaForm = functions.httpsCallable("controlaForm");
      controlaForm(payload)
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(data));
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  }
};
